import { StoreUtils } from '../../utils/util';

export const MASTERS = (): {
  [key: string]: {
    name: string;
    description: string;
    url: string;
  }[];
} => ({
  Sales: [
    {
      name: 'B2C Discount Master',
      description: 'Discount configuration and Profiles.',
      url: '/masters/b2c-discount-master',
    },
    // {
    //   name: 'HSN GST Master',
    //   description:
    //     'HSN GST Mapping Tool – These changes will be applied to inventory from 22 September 2025 onwards.',
    //   url: '/masters/hsn-gst-master',
    // },
    {
      name: 'Category Master',
      description: 'Inventory Categories.',
      url: '/masters/category-master',
    },
    {
      name: 'Brand Master',
      description: 'Inventory Brands.',
      url: '/masters/brand-master',
    },
  ],
});

export const REPORT_STATUS = {
  generated: 'Generated',
  pending: 'Pending',
  failed: 'Failed',
  synced: 'Synced',
};

export const moveColToFirst = (col: string[], name: string): string[] => {
  if (col.includes(name)) {
    return [name, ...col.filter((item) => item !== name)];
  }
  return col;
};

export const typePathMap: Record<string, string> = {
  Supplier: '/suppliers',
  Retailer: '/wholesale/retailers',
  Sales: '/bill-history',
  'Sales Return': '/sales-return-history',
  Purchase: '/purchase-history',
  'Purchase Return': '/purchase-return-history',
  Wholesale: '/wholesale/bill-history',
  'Wholesale Return': '/wholesale-return-history',
};

export const syncStatusMap: Record<string, { key: string; label: string; color: string }> = {
  pending: { key: 'pending', label: 'Pending', color: '#FF5733' }, // Orange-Red
  inProgress: { key: 'inProgress', label: 'In Progress', color: '#FF8C00' }, // Dark Orange
  partial: { key: 'partial', label: 'Partial', color: '#FFD700' }, // Gold
  done: { key: 'done', label: 'Done', color: '#4CAF50' }, // Green
  notApplicable: { key: 'notApplicable', label: 'Not Applicable', color: '#A9A9A9' }, // Dark Gray
  failed: { key: 'failed', label: 'Failed', color: '#B22222' }, // Firebrick Red
};

const reports = ['Tally', 'WMS', 'WMS B2C'];

export const getStoreCheck = (dataValue: string) => {
  switch (dataValue) {
    case 'WMS':
      return StoreUtils.isWMSStore();
    case 'WMS B2C':
      return StoreUtils.isWmsB2cStore();
    case 'Tally':
      return StoreUtils.getKeyFromActiveSession(['config', 'tallyIntegration']);
    default:
      return !reports.includes(dataValue);
  }
};
